import styled from 'styled-components';
import { SkeletonTheme } from 'react-loading-skeleton';

export const Container = styled(SkeletonTheme).attrs(({ theme }) => ({
  color: theme.bodyBackground,
  highlightColor: theme.componentBackground,
}))``;
